import { createContext, useContext } from 'react';
import { noop } from 'utils/noop';
import {
  PredictiveGoalQuery,
  InternalTemplates,
  InternalTemplateGoalQueriesMap,
  UserSelectedInternalTemplate,
} from '../../../types';
import { emptyGoal } from './contextUtils';

export interface PredictiveGoalContextState {
  queriedGoal: PredictiveGoalQuery;
  resetQueriedGoal: () => void;
  setUserTemplateSelection: (value: UserSelectedInternalTemplate) => void;
  userTemplateSelection: UserSelectedInternalTemplate;
  internalTemplateGoalQueries: InternalTemplateGoalQueriesMap;
  isTemplateEventDisabled: (value: UserSelectedInternalTemplate) => boolean;
}

export const defaultPredictiveGoalsState: PredictiveGoalContextState = {
  queriedGoal: emptyGoal,
  resetQueriedGoal: noop,
  setUserTemplateSelection: noop,
  userTemplateSelection: '',
  isTemplateEventDisabled: () => true,
  internalTemplateGoalQueries: {
    [InternalTemplates.CHURN]: emptyGoal,
    [InternalTemplates.ENGAGE]: emptyGoal,
    [InternalTemplates.PURCHASE]: emptyGoal,
  },
};

export const PredictiveGoalsContext = createContext<PredictiveGoalContextState>(
  defaultPredictiveGoalsState,
);
export const usePredictiveGoalsContext = () => useContext(PredictiveGoalsContext);
